$(function () {
  let section = $('#seccionReportePagos')
  if (section.get(0) == null) {
    return
  }

  let vueApp = new Vue({
    el: section.get(0),
    data: {
      loader: false,
      filtros: { page: 1, tipo_pago_id: null, producto_id: null, fecha_inicio: null, fecha_fin: null },
      grafico: {
        datos: [{
          titulo: "Sin resultados",
          valor: 0,
        }],
        grafico: "bar",
        min: 0,
        max: 200
      },
      productos: [],
      total: 0,
      cantidad: 0
    },
    mounted() {
      this.initDatePicker()
      this.getProductos()
    },
    methods: {
      getEncodedParams(){
        let params = Object.assign({}, this.filtros)
        delete params.page
        delete params.from
        delete params.to
        delete params.per_page
        delete params.total
        if(params.tipo_pago_id == null || params.tipo_pago_id.length == 0){
          delete params.tipo_pago_id
        }
        if(params.producto_id == null || params.producto_id.length == 0){
          delete params.producto_id
        }
        if(params.fecha_inicio == null || params.fecha_inicio.length == 0){
          delete params.fecha_inicio
        }
        if(params.fecha_fin == null || params.fecha_fin.length == 0){
          delete params.fecha_fin
        }
        return new URLSearchParams(params).toString();
      },
      getProductos(pagina = null) {
        if (this.loader) {
          return
        }
        if (pagina != null) {
          this.filtros.page = pagina
        }

        this.loader = true
        axios
          .get('/admin/reportes/pagos/json', {
            params: this.filtros,
          })
          .then((response) => {
            vueApp.loader = false
            if (response.data.error) {
              swal(response.data.error, '', 'info')
              return
            }

            vueApp.total = response.data.total;
            vueApp.cantidad = response.data.cantidad;
            vueApp.productos = response.data.productos.data;
            vueApp.filtros.total = response.data.productos.total;
            vueApp.filtros.per_page = response.data.productos.per_page;
            vueApp.filtros.from = response.data.productos.from;
            vueApp.filtros.to = response.data.productos.to;



            if(response.data.grafico != null){
              vueApp.grafico = Object.assign({}, response.data.grafico)
            }

            if (vueApp.filtros.fecha_inicio == null) {
              vueApp.setFechaInicio(response.data.fecha_inicio)
            }

            if (vueApp.filtros.fecha_fin == null) {
              vueApp.setFechaFin(response.data.fecha_fin)
            }
          })
          .catch((error) => {
            console.log(error)
            vueApp.loader = false
            swal('Ocurrió un error inesperado', '', 'warning')
          })
      },
      setFechaInicio(fecha) {
        this.filtros.fecha_inicio = fecha
        if (fecha != null) {
          fecha = fecha.split(' ')[0].split('-')
          fecha = [fecha[2], fecha[1], fecha[0]].join('/')
        }
        $('#fechaInicio').attr('value', fecha)
        $('#fechaInicio').datepicker('update', fecha)
      },
      setFechaFin(fecha) {
        this.filtros.fecha_fin = fecha
        if (fecha != null) {
          fecha = fecha.split(' ')[0].split('-')
          fecha = [fecha[2], fecha[1], fecha[0]].join('/')
        }
        $('#fechaFin').attr('value', fecha)
        $('#fechaFin').datepicker('update', fecha)
      },
      initDatePicker() {
        $('.fc-datepicker').datepicker({
          showOtherMonths: true,
          selectOtherMonths: true,
          autoclose: true,
          format: 'dd/mm/yyyy',
          language: 'es',
        })
        $('#fechaInicio')
          .datepicker()
          .on('changeDate', function (ev) {
            let fecha = $(ev.target).val()
            if (fecha != null) {
              fecha = fecha.split('/')
              fecha = [fecha[2], fecha[1], fecha[0]].join('-')
            }
            vueApp.filtros.fecha_inicio = fecha
            vueApp.getProductos(1)
          })
        $('#fechaFin')
          .datepicker()
          .on('changeDate', function (ev) {
            let fecha = $(ev.target).val()
            if (fecha != null) {
              fecha = fecha.split('/')
              fecha = [fecha[2], fecha[1], fecha[0]].join('-')
            }
            vueApp.filtros.fecha_fin = fecha
            vueApp.getProductos(1)
          })
      },
    },
  })

})
